"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["pullRight", "className", "children"];

var MenuItems = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var pullRight = _ref.pullRight,
      className = _ref.className,
      children = _ref.children,
      remainingProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var dropdownMenuClasses = (0, _classnames.default)('dropdown-menu', pullRight && 'pull-right', className);
  return /*#__PURE__*/_react.default.createElement("ul", (0, _extends2.default)({}, remainingProps, {
    className: dropdownMenuClasses,
    ref: ref,
    role: 'menu'
  }), children);
});

var _default = MenuItems;
exports.default = _default;